import UnlockHomework from './component';
import _routes from './routes';

export const routes = _routes;

export default UnlockHomework;



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/UnlockHomework/index.js